module.exports = __webpack_public_path__ + "static/media/09-aermel_brille.9d25963f.jpg";